import { inject, injectable } from 'inversify'
import {
  FetchCompanyArticlesUseCaseInput,
  FetchCompanyArticlesUseCaseOutput,
  IAppErrorFactory,
  IArticlesService,
  IFetchCompanyArticlesUseCase,
} from '../../types'
import symbols from '../../symbols'

@injectable()
export default class FetchCompanyArticlesInteractor implements IFetchCompanyArticlesUseCase {
  @inject(symbols.IArticlesService) private articlesService: IArticlesService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: FetchCompanyArticlesUseCaseInput): Promise<FetchCompanyArticlesUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      const { articles, hasNextPage } = await this.articlesService.fetchCompanyArticles(input)

      output.articles = articles
      output.hasNextPage = hasNextPage
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }

  private getDefaultOutputData(): FetchCompanyArticlesUseCaseOutput {
    return {
      articles: [],
      hasNextPage: true,
      error: null,
    }
  }
}
